import {
  LOAD_TASK,
  LOAD_TASK_SUCCESS,
  LOAD_TASK_FAIL,
  LOAD_PAGE_LOAD_TASK,
  LOAD_PAGE_LOAD_TASK_SUCCESS,
  LOAD_PAGE_LOAD_TASK_FAIL
} from 'redux/actions/sendSupportAction';

const initialState = {
  loaded: false,
  loading: false,
  loadedPageLoad: false,
  loadingPageLoad: false,
  taskList: [],
  taskListMore: []
};

function sendSupportReducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_TASK:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case LOAD_TASK_SUCCESS:
      // action.payload.data = JSON.parse('[{"taskId":123,"documentId":365,"client":"ecw name1","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd The length property returns the length of a string (number of characters). The length property returns the length of a string (number of characters).12828","response":"response abcd","comments":"comment abcd Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam consectetur venenatis blandit. Praesent vehicula, libero non pretium vulputate, lacus arcu facilisis lectus, sed test here","isReassigned":false},{"taskId":124,"documentId":365,"client":"ecw name2","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd","response":"response abcd","comments":"comment abcd","isReassigned":false},{"taskId":125,"documentId":365,"client":"ecw name3","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd","response":"response abcd","comments":"comment abcd","isReassigned":false},{"taskId":126,"documentId":365,"client":"ecw name6","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd","response":"response abcd","comments":"comment abcd","isReassigned":false},{"taskId":127,"documentId":365,"client":"ecw name7","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd","response":"response abcd","comments":"comment abcd","isReassigned":false},{"taskId":128,"documentId":365,"client":"ecw name8","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd","response":"response abcd","comments":"comment abcd","isReassigned":false},{"taskId":129,"documentId":365,"client":"ecw name9","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd","response":"response abcd","comments":"comment abcd","isReassigned":false},{"taskId":130,"documentId":365,"client":"ecw name30","clientId":"ecw","locationName":"test","locationId":159,"sourceId":159,"sourceName":"test","respondedBy":"test","timeIn":"","status":"Failed","review":"review abcd","response":"response abcd","comments":"comment abcd","isReassigned":false}]');
      const userTask = action.payload.data;
      return {
        ...state,
        loading: false,
        loaded: true,
        taskList: userTask
      };
    case LOAD_TASK_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    case LOAD_PAGE_LOAD_TASK:
      return {
        ...state,
        loadingPageLoad: true,
        loadedPageLoad: false
      };
    case LOAD_PAGE_LOAD_TASK_SUCCESS:
      const stateData = state.taskList;
      // const randomNumber = Math.random();
      // action.payload.data = JSON.parse('[{"taskId":12365676666, "documentId":3655,"client":"ecw name166666666666 -' + randomNumber + '"}]');
      const combinedLoadMore = action.payload.data ? stateData.concat(action.payload.data) : stateData;
      return {
        ...state,
        loadingPageLoad: false,
        loadedPageLoad: true,
        taskList: combinedLoadMore
      };
    case LOAD_PAGE_LOAD_TASK_FAIL:
      return {
        ...state,
        loadingPageLoad: false,
        loadedPageLoad: false,
        error: action.error
      };
    default:
      return state;
  }
}
export default sendSupportReducer;
